import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// Plugins
import { DataTablesModule } from 'angular-datatables';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { BsDropdownModule } from 'ngx-bootstrap';
// import { DatepickerModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';

// import filepond module
import { FilePondModule, registerPlugin } from 'ngx-filepond';

// import and register filepond plugins
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

import { ChartsModule } from 'ng2-charts';
import { NavigationComponent } from '../../shared/header-navigation/navigation.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

registerPlugin(
  // encodes the file as base64 data
  FilePondPluginFileEncode,
  // validates files based on input type
  FilePondPluginFileValidateType,
  // Validate image size
  FilePondPluginImageValidateSize,
  // corrects mobile image orientation
  FilePondPluginImageExifOrientation,
  // previews the image
  FilePondPluginImagePreview,
  // crops the image to a certain aspect ratio
  FilePondPluginImageCrop,
  // resizes the image to fit a certain size
  FilePondPluginImageResize,
  // applies crop and resize information on the client
  FilePondPluginImageTransform
);

// Custom Pipes
import { ApplicationPipesModule } from '../../services/pipes/application-pipes.module';

// Material Design Imports
import {
  // MatAutocompleteModule,
  // MatButtonModule,
  // MatButtonToggleModule,
  // MatCardModule,
  // MatCheckboxModule,
  // MatChipsModule,
  // MatDatepickerModule,
  // MatDialogModule,
  // MatExpansionModule,
  // MatGridListModule,
  // MatIconModule,
  // MatInputModule,
  // MatListModule,
  // MatMenuModule,
  // MatNativeDateModule,
  // MatProgressBarModule,
  // MatProgressSpinnerModule,
  MatRadioModule,
  // MatRippleModule,
  // MatSelectModule,
  // MatSidenavModule,
  // MatSliderModule,
  // MatSlideToggleModule,
  // MatSnackBarModule,
  // MatStepperModule,
  // MatTableModule,
  // MatTabsModule,
  // MatToolbarModule,
  // MatTooltipModule,
  // MatFormFieldModule,
} from '@angular/material';

// Set Routing
import { SalesRoutingModule } from './sales-routing.module';

// Set Pages
import { AvailableSubscriptionsComponent } from './available-subscriptions/available-subscriptions.component';
import { AvailableLeadsComponent } from './available-leads/available-leads.component';
import { UnPaidOrderComponent } from './un-paid-order/un-paid-order.component';
import { ClosedOrdersComponent } from './closed-orders/closed-orders.component';
import { UserPackagesSalesComponent } from './user-packages/user-packages.component';

@NgModule({
  declarations: [
    AvailableSubscriptionsComponent,
    AvailableLeadsComponent,
    UnPaidOrderComponent,
    ClosedOrdersComponent,
    UserPackagesSalesComponent,
  ],
  imports: [
    SalesRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,

    DataTablesModule,
    FilePondModule,

    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PopoverModule.forRoot(),
    // DatepickerModule.forRoot(),
    // DatetimePopupModule.forRoot(),
    MatRadioModule,

    // Custom Pipes Modules
    ApplicationPipesModule,
    NgSelectModule,
    ChartsModule,
    EditorModule,
    NgxSliderModule,
  ],
})
export class SalesModule {}
